<div class="container" flexLayout="column" flexLayoutAlign="start start">
  <h1>We Apologize</h1>
  <p>
    Unfortunately, an error has occurred. Our team has been notified and is working to resolve the
    issue as quickly as possible. Please try again later or
    <a href="#">contact support</a> if the problem persists.
  </p>
</div>
